import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  getLatestSignatureRequest,
  SignatureRequest,
} from '@app/features/contracts/signature/signature-request.model';
import { LucideCircleX, LucideClockAlert, LucideTrash } from '@lucide/angular';
import { SignatureRequestStatusLabelPipe } from '../signature-request-status-label-pipe';

@Component({
  selector: 'app-signature-request-status',
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    SignatureRequestStatusLabelPipe,
    LucideTrash,
    LucideCircleX,
    LucideClockAlert,
  ],
  templateUrl: './signature-request-status.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./signature-request-status.scss'],
})
export class SignatureRequestStatus {
  signatureRequests = input<SignatureRequest[]>();

  cdr = inject(ChangeDetectorRef);
  datePipe = new DatePipe('fr-FR');
  latestSignatureRequest?: SignatureRequest;

  constructor() {
    effect(() => {
      this.latestSignatureRequest = getLatestSignatureRequest(this.signatureRequests());
      this.cdr.markForCheck();
    });
  }

  get at() {
    if (!this.latestSignatureRequest) {
      return '';
    }

    const { activatedAt, signedAt, expiresAt } = this.latestSignatureRequest;
    switch (this.latestSignatureRequest.status) {
      case 'ongoing':
        return activatedAt ? `le ${this.datePipe.transform(activatedAt, 'shortDate')}` : '';
      case 'expired':
        return expiresAt ? `le ${this.datePipe.transform(expiresAt, 'shortDate')}` : '';
      case 'done':
        return signedAt ? `le ${this.datePipe.transform(signedAt, 'shortDate')}` : '';
      default:
        return '';
    }
  }
}
